import * as types from '../actions/actionTypes';
import Config from "../config";
import {parseFabricatorSettings} from "./fabricatorReducer";

const removeTutorial = Config.isVisualizerManagement();

const initialState = {
  materialsTutorialIsOpened: false,
  materialsTutorialStep: 0,
  materialsTutorialFinished: removeTutorial,
  visualizerTutorialIsOpened: false,
  visualizerTutorialStep: 1,
  visualizerTutorialFinished: removeTutorial,
  materialsAgentTutorialIsOpened: false,
  materialsAgentTutorialFinished: false,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SHOW_MATERIALS_TUTORIAL:
    case types.SET_MATERIALS_TUTORIAL_STEP:
    case types.SET_MATERIALS_TUTORIAL_FINISHED:
    case types.SHOW_MATERIALS_AGENT_TUTORIAL:
    case types.SET_MATERIALS_AGENT_TUTORIAL_FINISHED:
    case types.SHOW_VISUALIZER_TUTORIAL:
    case types.SET_VISUALIZER_TUTORIAL_STEP:
    case types.SET_VISUALIZER_TUTORIAL_FINISHED:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_FABRICATOR_DATA: {
      if (action.payload && action.payload.settings) {
        const {settings} = parseFabricatorSettings(action.payload);
        if (!settings.showVisualizerTutorial) {
          return Object.assign({}, state, {
            materialsTutorialFinished: true,
            visualizerTutorialFinished: true
          });
        }
      }
      return Object.assign({}, state);
    }

  }

  return state;

}
